import React, { useEffect } from 'react'

import { useDispatch } from 'react-redux'
import { useRouteMatch } from 'react-router-dom'

import {
  changeInitialLoadedAction,
  clearSearchListProfileAction,
  fetchSearchListProfileAction,
} from 'actions/search/searchListProfileAction'
import { Cursor } from 'api/search/search.types'
import { MarginSearchBottom } from 'components/page/ForeignProfile/ForeignProfile.styled'
import { SearchListGrid } from 'components/page/Search/SearchListGrid'
import { DEFAULT_SEARCH_LIMIT } from 'components/page/Search/searchPromoFunctions'
import { ProfileRouteParams } from 'components/paths'
import { DefaultLoader } from 'components/presentational/AnimatedWatch/AnimatedWatch'
import { useReducersInsert } from 'hooks/useReducersInsert'
import { useShallowEqualSelector } from 'hooks/useShallowEqualSelector'
import { searchListProfileReducer } from 'reducers/search/searchListProfileReducer'

export const SearchProfile = () => {
  useReducersInsert({ searchListProfile: searchListProfileReducer })
  const dispatch = useDispatch()
  const match = useRouteMatch()

  const { resultLoading, resultLoaded, isEnd, items, initialLoaded } =
    useShallowEqualSelector(
      ({
        searchListProfile: {
          resultLoading,
          resultLoaded,
          isEnd,
          items,
          initialLoaded,
        },
      }) => ({
        resultLoading,
        resultLoaded,
        isEnd,
        items,
        initialLoaded,
      })
    )

  const requestNextChunk = () => {
    if (match) {
      dispatch(
        fetchSearchListProfileAction(
          DEFAULT_SEARCH_LIMIT,
          match.params as Cursor & ProfileRouteParams
        )
      )
    }
  }

  useEffect(() => {
    if (!initialLoaded) {
      dispatch(changeInitialLoadedAction())
      requestNextChunk()
    }
  }, [dispatch, initialLoaded])

  useEffect(() => {
    return () => {
      dispatch(clearSearchListProfileAction())
    }
  }, [dispatch])

  return (
    <MarginSearchBottom>
      <SearchListGrid
        items={items}
        loading={resultLoading}
        loaded={resultLoaded}
        onLoadNewChunk={requestNextChunk}
        isEnd={isEnd}
      />
      {!isEnd && resultLoading && <DefaultLoader />}
    </MarginSearchBottom>
  )
}
